import React from 'react';

import {
  Avatar,
  List as MUIList,
  ListItem as MUIListItem,
  ListItemButton as MUIListItemButton,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import { styled, Icon } from '@liscio/ui';

import { DrawerProps } from '../../Drawer';

type LoggedUserProps = Pick<
  DrawerProps,
  | 'onNavigationClick'
  | 'selectedOptionValue'
  | 'name'
  | 'avatarUrl'
  | 'isLoading'
>;

const List = styled(MUIList)(() => ({
  paddingBottom: '16px',
}));
const ListItem = styled(MUIListItem)(({ theme }) => ({
  'svg path': {
    fill: theme.palette.primary.contrastText,
  },
}));
const ListItemButton = styled(MUIListItemButton)(({ theme }) => ({
  paddingTop: '12px',
  paddingBottom: '12px',
  '&.Mui-selected': {
    backgroundColor: theme.brandColors.dark,
  },
}));

export const LoggedUser: React.FC<LoggedUserProps> = ({
  selectedOptionValue,
  onNavigationClick,
  name,
  avatarUrl,
  isLoading,
}) => (
  <List>
    <ListItem disablePadding>
      <ListItemButton
        selected={selectedOptionValue === 'profile'}
        onClick={() => onNavigationClick && onNavigationClick(`profile`)}
        disabled={isLoading}
      >
        <ListItemAvatar>
          <Avatar alt={name} src={avatarUrl} sx={{ width: 24, height: 24 }} />
        </ListItemAvatar>
        <ListItemText>{name}</ListItemText>
      </ListItemButton>
    </ListItem>
    <ListItem disablePadding>
      <ListItemButton
        onClick={() => onNavigationClick && onNavigationClick(`logout`)}
        disabled={isLoading}
      >
        <ListItemIcon>
          <Icon icon="logout" />
        </ListItemIcon>
        <ListItemText>Logout</ListItemText>
      </ListItemButton>
    </ListItem>
  </List>
);

export default LoggedUser;
